"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tons = exports.hundredweights = exports.pennyweights = exports.drams = exports.dryBarrels = exports.bushels = exports.pecks = exports.dryGallons = exports.dryQuarts = exports.dryPints = exports.hogsheads = exports.oilBarrels = exports.barrels = exports.gallons = exports.quarts = exports.pints = exports.cups = exports.gills = exports.shots = exports.fluidOunces = exports.tablespoons = exports.teaspoons = exports.fluidDrams = exports.minims = exports.picas = exports.points = void 0;
var numberMeasure_1 = require("../measure/numberMeasure");
var base_1 = require("./base");
var common_1 = require("./common");
var metric_1 = require("./metric");
var other_1 = require("./other");
// Length
exports.points = numberMeasure_1.Measure.of(352.778, (0, metric_1.micro)(base_1.meters), "p");
exports.picas = numberMeasure_1.Measure.of(12, exports.points, "pica");
// Liquid volume
exports.minims = numberMeasure_1.Measure.of(61.611519921875, (0, metric_1.micro)(other_1.liters), "min");
exports.fluidDrams = numberMeasure_1.Measure.of(60, exports.minims, "fl dr");
exports.teaspoons = numberMeasure_1.Measure.of(80, exports.minims, "tsp");
exports.tablespoons = numberMeasure_1.Measure.of(3, exports.teaspoons, "Tbsp");
exports.fluidOunces = numberMeasure_1.Measure.of(2, exports.tablespoons, "fl oz");
exports.shots = numberMeasure_1.Measure.of(3, exports.tablespoons, "jig");
exports.gills = numberMeasure_1.Measure.of(4, exports.fluidOunces, "gi");
exports.cups = numberMeasure_1.Measure.of(2, exports.gills, "cp");
exports.pints = numberMeasure_1.Measure.of(2, exports.cups, "pt");
exports.quarts = numberMeasure_1.Measure.of(2, exports.pints, "qt");
exports.gallons = numberMeasure_1.Measure.of(4, exports.quarts, "gal");
exports.barrels = numberMeasure_1.Measure.of(31.5, exports.gallons, "liq bbl");
exports.oilBarrels = numberMeasure_1.Measure.of(42, exports.gallons, "bbl");
exports.hogsheads = numberMeasure_1.Measure.of(63, exports.gallons, "hogshead");
// Dry volume
exports.dryPints = numberMeasure_1.Measure.of(0.5506104713575, other_1.liters, "dry pt");
exports.dryQuarts = numberMeasure_1.Measure.of(2, exports.dryPints, "dry qt");
exports.dryGallons = numberMeasure_1.Measure.of(4, exports.dryQuarts, "dry gal");
exports.pecks = numberMeasure_1.Measure.of(2, exports.dryGallons, "pk");
exports.bushels = numberMeasure_1.Measure.of(4, exports.pecks, "bu");
exports.dryBarrels = numberMeasure_1.Measure.of(7056, common_1.inches.cubed(), "dry bbl");
// Mass
exports.drams = numberMeasure_1.Measure.of(1.7718451953125, common_1.grams, "dr");
exports.pennyweights = numberMeasure_1.Measure.of(24, common_1.grains, "dwt");
exports.hundredweights = numberMeasure_1.Measure.of(100, common_1.pounds, "cwd");
exports.tons = numberMeasure_1.Measure.of(2000, common_1.pounds, "ton");
//# sourceMappingURL=uscu.js.map